import { createAction } from 'redux-actions'

import * as constants from './constants'

export const fetchTeamMemberAttribs = createAction(constants.FETCH_TEAMMEMBER_ATTRIBS)
export const fetchTeamMemberAttribsPending = createAction(constants.FETCH_TEAMMEMBER_ATTRIBS_PENDING)
export const fetchTeamMemberAttribsSuccess = createAction(constants.FETCH_TEAMMEMBER_ATTRIBS_SUCCESS)
export const fetchTeamMemberAttribsFailed = createAction(constants.FETCH_TEAMMEMBER_ATTRIBS_FAILED)
export const fetchTeamMemberAttribsCancelled = createAction(constants.FETCH_TEAMMEMBER_ATTRIBS_CANCELLED)

export const fetchAccountAttribs = createAction(constants.FETCH_ACCOUNT_ATTRIBS)
export const fetchAccountAttribsPending = createAction(constants.FETCH_ACCOUNT_ATTRIBS_PENDING)
export const fetchAccountAttribsSuccess = createAction(constants.FETCH_ACCOUNT_ATTRIBS_SUCCESS)
export const fetchAccountAttribsFailed = createAction(constants.FETCH_ACCOUNT_ATTRIBS_FAILED)
export const fetchAccountAttribsCancelled = createAction(constants.FETCH_ACCOUNT_ATTRIBS_CANCELLED)

export const fetchAccountSegments = createAction(constants.FETCH_ACCOUNT_SEGMENTS)
export const fetchAccountSegmentsPending = createAction(constants.FETCH_ACCOUNT_SEGMENTS_PENDING)
export const fetchAccountSegmentsFailed = createAction(constants.FETCH_ACCOUNT_SEGMENTS_FAILED)
export const fetchAccountSegmentsCancelled = createAction(constants.FETCH_ACCOUNT_SEGMENTS_CANCELLED)
export const fetchAccountSegmentsSuccess = createAction(constants.FETCH_ACCOUNT_SEGMENTS_SUCCESS)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/account/actions.js